import Phaser from 'phaser';
import { BootScene } from '@game/scenes/BootScene';
import { PreloadScene } from '@game/scenes/PreloadScene';
import { MenuScene } from '@game/scenes/MenuScene';
import { CellDemoScene } from '@game/scenes/CellDemoScene';
import { DiscoveryScene } from '@game/scenes/DiscoveryScene';
import { ClassificationScene } from '@game/scenes/ClassificationScene';
import { SimulationScene } from '@game/scenes/SimulationScene';
import { BuilderScene } from '@game/scenes/BuilderScene';
import { ProgressDashboardScene } from '@game/scenes/ProgressDashboardScene';
import { SettingsScene } from '@game/scenes/SettingsScene';
import { AboutScene } from '@game/scenes/AboutScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: 1280,
  height: 720,
  backgroundColor: '#0A1628',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'arcade',
    arcade: {
      debug: false,
    },
  },
  scene: [BootScene, PreloadScene, MenuScene, CellDemoScene, DiscoveryScene, ClassificationScene, SimulationScene, BuilderScene, ProgressDashboardScene, SettingsScene, AboutScene],
};

// Remove loading screen once game starts
window.addEventListener('load', () => {
  const loading = document.getElementById('loading');
  if (loading) {
    loading.style.display = 'none';
  }
});

// Initialize game
new Phaser.Game(config);
